<template>
  <div class="animated revealUp">
    <div class="section-title mb-4">
      {{ $t("transaction") }} {{ $tc("swap", 1) }}
    </div>
    <div class="white-wrapper">
      <div class="row">
        <div class="col-lg-4 col-xl-3 align-self-center mb-4">
          <div class="dropdown-curve-container mr-2">
            <label :class="selectedCinema ? 'shift-up' : ''"
              >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
            >
            <b-dropdown
              :text="selectedCinema"
              variant="dropdown-curve"
              class="w-100"
            >
              <div class="px-2 pb-2">
                <input
                  required
                  autofocus
                  type="search"
                  :placeholder="$tc('searchCinema')"
                  class="form-control form-control-sm"
                  v-on:keyup="onSearchCinema()"
                  v-on:keydown="onSearchCinema()"
                  v-on:search="onSearchCinema()"
                  v-model="searchCinema"
                />
              </div>
              <b-dropdown-item
                v-for="(dropdownItem, dropdownIndex) in Cinemas"
                :key="dropdownIndex"
                @click="onSelectCinema(dropdownItem)"
                >{{ dropdownItem.cine_name }}</b-dropdown-item
              >
            </b-dropdown>
          </div>
        </div>

        <div class="col-lg-4 col-xl-2 align-self-center mb-4">
          <div class="input-material">
            <div class="add-datepicker">
              <button
                class="btn-clearDate"
                v-if="fromDate"
                @click="fromDate = ''"
              >
                ✖
              </button>
              <Datepicker
                :monday-first="true"
                ref="programaticOpen"
                v-model="fromDate"
                name="fromDate"
                id="fromDate"
                :typeable="true"
                @selected="onChangeDate($event, 'from')"
              ></Datepicker>
              <label :class="fromDate ? 'active' : ''">{{
                $t("startdate")
              }}</label>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-xl-2 align-self-center mb-4">
          <div class="input-material">
            <div class="add-datepicker">
              <button class="btn-clearDate" v-if="toDate" @click="toDate = ''">
                ✖
              </button>
              <Datepicker
                :monday-first="true"
                ref="programaticOpen"
                v-model="toDate"
                name="toDate"
                id="toDate"
                :typeable="true"
              ></Datepicker>
              <label :class="toDate ? 'active' : ''">{{ $t("enddate") }}</label>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-xl-2 align-self-center mb-4">
          <button @click="fetchSwapTransactions()" class="btn-blue-lg w-100">
            {{ $tc("submit") }}
          </button>
        </div>

        <div
          v-if="swapTransaction.length > 0"
          class="col-lg-4 col-xl-3 align-self-center mb-4"
          style="text-align: right; cursor: pointer"
        >
          <a target="_blank" title="Download as Excel" @click="excelDownload()">
            Download as:<img
              class="mx-1"
              src="@/assets/img/icons/excel.svg"
              height="25"
              width="25"
            />
          </a>
          <!-- <a target="_blank" @click="generateReport()" title="Download as PDF">
            <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
          </a> -->
          <img
            @click="fetchSwapTransactions('Y')"
            src="@/assets/img/icons/pdf-icon.svg"
            height="25"
            width="25"
          />
        </div>
      </div>

      <div class="swc-report" style="overflow-x: auto">
        <table
          class="swc-report-table swap-report"
          border="1"
          style="width: auto !important"
        >
          <thead>
            <tr class="bg-lightgrey">
              <th colspan="15">New</th>
              <th colspan="13">Old</th>
            </tr>
            <tr class="bg-lightgrey">
              <th colspan="2">
                {{ $t("transaction") }} {{ $t("number") }} (N)
              </th>
              <th colspan="2">{{ $tc("movie", 1) }} {{ $t("name") }} (N)</th>
              <th>{{ $tc("booking", 1) }} {{ $tc("date", 1) }} (N)</th>
              <th>{{ $t("show") }} {{ $tc("date", 1) }} (N)</th>
              <th>{{ $t("show") }} {{ $tc("time", 1) }} (N)</th>
              <th>{{ $tc("screen", 1) }} {{ $tc("name", 1) }} (N)</th>
              <th>{{ $tc("seat", 1) }} {{ $tc("number", 1) }} (N)</th>
              <th>{{ $t("total") }} {{ $t("amount") }} (N)</th>
              <th>{{ $t("hslocation") }} (N)</th>
              <th>{{ $t("swapped") }} {{ $t("by") }}</th>
              <th>{{ $t("swapsource") }}</th>
              <th>{{ $t("authorizedBy") }}</th>
              <th>Time Difference</th>
              <th colspan="2">
                {{ $t("transaction") }} {{ $t("number") }} (O)
              </th>
              <th colspan="2">{{ $tc("movie", 1) }} {{ $t("name") }} (O)</th>
              <th>{{ $tc("booking", 1) }} {{ $tc("date", 1) }} (O)</th>
              <th>{{ $t("show") }} {{ $tc("date", 1) }} (O)</th>
              <th>{{ $t("show") }} {{ $tc("time", 1) }} (O)</th>
              <th>{{ $tc("screen", 1) }} {{ $tc("name", 1) }} (O)</th>
              <th>{{ $tc("seat", 1) }} {{ $tc("number", 1) }} (O)</th>
              <th>{{ $t("amount") }} (O)</th>
              <th>{{ $t("bs_hslocation") }} (O)</th>
              <th>{{ $t("booked") }} {{ $t("by") }}</th>
              <th>{{ $tc("bookingsource", 1) }} (O)</th>
            </tr>
          </thead>

          <tbody
            v-if="swapTransaction.length > 0"
            class="sph-report"
            :style="cssVars"
          >
            <tr
              v-for="(transaction, transactionIndex) in swapTransaction"
              :key="transactionIndex"
            >
              <td colspan="2">{{ transaction.sb_booking_code }}</td>
              <td colspan="2" class="text-left">{{ transaction.film_name }}</td>
              <td>{{ transaction.t_booking_date_time | fulldatemonparse }}</td>
              <td>{{ transaction.t_show_date | dateparse }}</td>
              <td class="text-right">{{ transaction.t_show_time }}</td>
              <td class="text-left">{{ transaction.screen_name }}</td>
              <td class="text-right">{{ transaction.seats }}</td>
              <td class="text-right">
                {{ currFormat(transaction.total_amount) }}
              </td>
              <td class="text-right">{{ transaction.location_name || "-" }}</td>
              <td class="text-right">{{ transaction.booking_user_name }}</td>
              <td class="text-right">{{ transaction.bs_source }}</td>
              <td class="text-right">{{ transaction.trx_authorized_by }}</td>
              <td class="text-right">
                {{
                  transaction.time_difference < 0
                    ? transaction.time_difference
                    : "-"
                }}
              </td>
              <td colspan="2" class="swap">
                {{ transaction.swap_sb_booking_code }}
              </td>
              <td colspan="2" class="swap text-left">
                {{ transaction.swap_film_name }}
              </td>
              <td class="swap">
                {{ transaction.swap_t_booking_date_time | fulldatemonparse }}
              </td>
              <td class="swap">
                {{ transaction.swap_t_show_date | dateparse }}
              </td>
              <td class="swap text-right">
                {{ transaction.swap_t_show_time }}
              </td>
              <td class="swap text-left">{{ transaction.swap_screen_name }}</td>
              <td class="swap text-right">{{ transaction.swap_seats }}</td>
              <td class="swap text-right">
                {{ currFormat(transaction.swap_total_amount) }}
              </td>
              <td class="swap text-right">
                {{ transaction.swap_location_name || "-" }}
              </td>
              <td class="swap text-left">
                {{ transaction.swap_booking_user_name }}
              </td>
              <td class="swap text-left">{{ transaction.swap_bs_source }}</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="27">
                <!-- <p class="text-center h6">{{ $tc("NoRecords") }}</p> -->
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import { mapState, mapGetters, mapActions } from "vuex";
import MasterService from "@/services/MasterService";
import ExhibitorService from "@/services/ExhibitorService";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import xlsx from "json-as-xlsx";
import VueHtml2pdf from "vue-html2pdf";

export default {
  components: { DatePicker, NoRecords, VueHtml2pdf },
  data() {
    return {
      Cinemas: [],
      CinemasCopy: [],
      searchCinema: "",
      swapTransaction: [],
      selectedCinema: "",
      fromDate: moment().format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
      cinema_id: null,
      swapTextColor: null,
      htmlToPdfOptions: {
        filename: "Box Office Receipt Report",
        margin: 2,
        image: {
          type: "jpeg",
          quality: 2
        },
        html2canvas: {
          scale: 1,
          useCORS: true
        },
        jsPDF: {
          format: "a2",
          orientation: "landscape"
        }
      }
    };
  },
  computed: {
    cssVars() {
      return {
        "--swap-color": this.swapTextColor
      };
    }
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    // if (CinemaObj) {
    //   this.onSelectCinema(CinemaObj);
    // }
  },
  watch: {
    // "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
    //   if (CinemaObj) {
    //     this.onSelectCinema(CinemaObj);
    //   }
    // }
  },
  mounted() {
    let cinemaId =
      this.secureStore.get("USINFO") &&
      this.secureStore.get("USINFO")["cinema_id"]
        ? this.secureStore.get("USINFO").cinema_id
        : null;
    this.getCinemaList(cinemaId);
  },
  methods: {
    onChangeDate: function(e, type){
      if(type == 'from'){
        this.toDate = new Date(e);
        this.$forceUpdate();
      }
    },
    async beforeDownload({ html2pdf, options, pdfContent }) {
      // const date = new Date();
      let cinemaName = this.selectedCinema;
      let fromDate = this.fromDate
        ? moment(this.fromDate).format("YYYY-MM-DD")
        : null;
      let toDate = this.toDate
        ? moment(this.toDate).format("YYYY-MM-DD")
        : null;
      var today = new Date();
      var date =
        String(today.getDate()).padStart(2, "0") +
        "-" +
        String(today.getMonth() + 1).padStart(2, "0") +
        "-" +
        today.getFullYear();
      var time =
        String(today.getHours()).padStart(2, "0") +
        ":" +
        String(today.getMinutes()).padStart(2, "0") +
        ":" +
        String(today.getSeconds()).padStart(2, "0");

      var dateTime = date + "_AT_" + time;
      this.pdfFileName =
        "Reports" + `${cinemaName}_${fromDate}_${toDate}_on${dateTime}`;
      this.htmlToPdfOptions.filename = this.pdfFileName;
      await html2pdf()
        .set(this.htmlToPdfOptions)
        .from(pdfContent)
        .toPdf()
        .get("pdf")
        .then(pdf => {
          const totalPages = pdf.internal.getNumberOfPages();
          for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            pdf.setFontSize(18);
            pdf.setTextColor(150);
            pdf.text(
              "Page " + i + " of " + totalPages,
              pdf.internal.pageSize.getWidth() * 0.88,
              pdf.internal.pageSize.getHeight() - 0.3
            );
          }
        })
        .save();
    },
    generateReport() {
      this.$refs.html2Pdf &&
        this.$refs.html2Pdf.generatePdf &&
        this.$refs.html2Pdf.generatePdf();
    },
    excelDownload() {
      let temp_data = this.swapTransaction;
      // let temp_arr = [];
      // temp_data.map(x => {
      //   x.selectedUsers.map(y => {
      //     let obj = {
      //       ...x,
      //       ...y
      //     };
      //     temp_arr.push(obj);
      //   });
      // });
      // console.log({temp_arr})
      let dateparse = function(value) {
        if (!value) return "-";
        else if (value === "Invalid date") return "-";
        else if (moment(value, "DD-MM-YYYY HH:mm", true).isValid())
          return value
            ? moment(value, "DD-MM-YYYY HH:mm").format("DD-MMM-YYYY")
            : "-";
        //else return value ? moment(value).format('DD-MM-YYYY') === 'Invalid date' ? '-' : moment(value).format('DD-MM-YYYY') : '-';
        //this is changed acc to mams decision
        else
          return value
            ? moment(value).format("DD-MM-YYYY") === "Invalid date"
              ? "-"
              : moment(value).format("DD-MMM-YYYY")
            : "-";
      };
      let fulldatemonparse = function(value) {
        if (!value) return "-";
        else if (value === "Invalid date") return "-";
        else if (moment(value, "DD-MM-YYYY HH:mm", true).isValid())
          return value
            ? moment(value, "DD-MM-YYYY HH:mm").format("DD-MMM-YYYY HH:mm")
            : "-";
        //else return value ? moment(value).format('DD-MM-YYYY') === 'Invalid date' ? '-' : moment(value).format('DD-MM-YYYY') : '-';
        //this is changed acc to mams decision
        else
          return value
            ? moment(value).format("DD-MM-YYYY") === "Invalid date"
              ? "-"
              : moment(value).format("DD-MMM-YYYY HH:mm")
            : "-";
      };

      let data = [
        {
          sheet: "Transaction Swap",
          columns: [
            {
              value: "sb_booking_code",
              label: "Transaction Number (N)"
            },
            {
              value: "film_name",
              label: "Movie Name (N)"
            },
            {
              value: row => fulldatemonparse(row.t_booking_date_time),
              label: "Booking Date (N)"
            },
            {
              value: row => dateparse(row.t_show_date),
              label: "Show Date (N)"
            },
            {
              value: "t_show_time",
              label: "Show Time (N)"
            },
            {
              value: "screen_name",
              label: "Screen Name (N)"
            },
            {
              value: "seats",
              label: "Seat Number (N)"
            },
            {
              value: "total_amount",
              label: "Total Sales Price (N)"
            },
            {
              value: "location_name",
              label: "Hardware Location (N)"
            },
            {
              value: "booking_user_name",
              label: "Swapped By"
            },
            {
              value: "bs_source",
              label: "Swap Source"
            },
            {
              value: "trx_authorized_by",
              label: "Authorized By"
            },
            {
              value: "time_difference",
              label: "Time Difference"
            },
            {
              value: "swap_sb_booking_code",
              label: "Transaction Number (O)"
            },
            {
              value: "swap_film_name",
              label: "Movie Name (O)"
            },
            {
              value: row => fulldatemonparse(row.swap_t_booking_date_time),
              label: "Booking Date (O)"
            },
            {
              value: row => dateparse(row.swap_t_show_date),
              label: "Show Date (O)"
            },
            {
              value: "swap_t_show_time",
              label: "Show Time (O)"
            },
            {
              value: "swap_screen_name",
              label: "Screen Name (O)"
            },
            {
              value: "swap_seats",
              label: "Seat Number (O)"
            },
            {
              value: "swap_total_amount",
              label: "Sales Price (O)"
            },
            {
              value: "swap_location_name",
              label: "Booking Location (O)"
            },
            {
              value: "swap_booking_user_name",
              label: "Booked By"
            },
            {
              value: "swap_bs_source",
              label: "Booking Source (O)"
            }
          ],
          content: temp_data
        }
      ];
      let cinemaName = this.selectedCinema;
      let fromDate = this.fromDate
        ? moment(this.fromDate).format("YYYY-MM-DD")
        : null;
      let toDate = this.toDate
        ? moment(this.toDate).format("YYYY-MM-DD")
        : null;
      var today = new Date();
      var date =
        String(today.getDate()).padStart(2, "0") +
        "-" +
        String(today.getMonth() + 1).padStart(2, "0") +
        "-" +
        today.getFullYear();
      var time =
        String(today.getHours()).padStart(2, "0") +
        ":" +
        String(today.getMinutes()).padStart(2, "0") +
        ":" +
        String(today.getSeconds()).padStart(2, "0");

      var dateTime = date + "_AT_" + time;
      let settings = {
        fileName: `TransactionSwap_${cinemaName}_${fromDate}_${toDate}_on${dateTime}`
      };
      xlsx(data, settings);
    },
    fetchSwapTransactions(payload) {
      if (this.selectedCinema == "" || !this.cinema_id) {
        return this.$toasted.show("Please Select Cinema");
      } else if (this.fromDate == "") {
        return this.$toasted.show("Please Enter From Date");
      } else if (this.toDate == "") {
        return this.$toasted.show("Please Enter To Date");
      } else if (this.fromDate > this.toDate) {
        return this.$toasted.show("To date must be greater than From Date");
      } else {
        this.getSwapTransaction(payload);
      }
    },
    onSelectCinema(cinema) {
      this.selectedCinema = cinema.cine_name;
      this.cinema_id = cinema.cine_id;
      this.$store.dispatch("selectDropdownCinema", cinema);
    },
    onSearchCinema: function() {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter(x => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },

    getSwapTransaction(isPdf = "N") {
      let loader = this.$loading.show();
      this.swapTransaction = [];
      let payload = {
        fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.toDate).format("YYYY-MM-DD"),
        cinema_id: this.cinema_id,
        isPdf
      };
      ExhibitorService.GetSwapTransactions(payload)
        .then(response => {
          const { data } = response;
          console.log("data", data);
          if (data && data.status) {
            if (data.Records.length === 0) {
              this.$toasted.show("No Record Found");
            } else {
              this.swapTransaction = data.Records;
              this.swapTextColor =
                data.hasOwnProperty("SwapColor") && data.SwapColor.length > 0
                  ? data.SwapColor[0].color
                  : null;
                  console.log("pdfPath",isPdf,data.pdfpath)
              if(isPdf=="Y" && data.pdfpath){
                window.open(data.pdfpath, "_blank");    
            }
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(err => {
          console.log("Error:", err);
        })
        .finally(() => {
          setTimeout(() => loader.hide(), 660);
        });
    },

    getCinemaList: function(cine_id) {
      this.Cinemas = [];
      MasterService.GetCinemasByRoles({ cine_id: cine_id })
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
            // this.CinemasCopy = data.Records;
            this.Cinemas.map(x => {
              if (String(cine_id) === String(x.cine_id)) {
                this.selectedCinema = x.cine_name;
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    }
  }
};
</script>

<style>
.swap {
  color: var(--swap-color);
}

.swap-report {
  /* white-space: unset!important; */
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/TransactionSwap/viewSwapTransactions.vue